import Stack from "@mui/material/Stack";
import { useMemo } from "react";
import { HighchartsProvider } from "@/storybook/c8r-highcharts/common/components/HighchartsProvider";
import { MultiTypeHighcharts } from "@/storybook/c8r-highcharts/MultiTypeHighcharts";
import { getHighChartsYAxisLabelsFormatter } from "@/storybook/c8r-highcharts/common/utils/helpers/getHighChartsYAxisLabelsFormatter";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsHistoryChartDataSelector } from "@/store/budgets/selectors/details-drawer/history/budgetDetailsHistoryChartDataSelector";
import { budgetDetailsHistoryProcessedDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { getBudgetDetailsHistoryChartTooltipValueGetter } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/utils/helpers/getBudgetDetailsHistoryChartTooltipValueGetter";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";

export const BudgetDetailsHistoryChart = () => {
  const processedData = useAppSelector(
    budgetDetailsHistoryProcessedDataSelector,
  );
  const loading = useAppSelector(budgetDetailsByIdLoadingSelector);

  const chartData = useAppSelector(budgetDetailsHistoryChartDataSelector);

  const tooltipValueFormatter = useMemo(
    () => getBudgetDetailsHistoryChartTooltipValueGetter(processedData),
    [processedData],
  );

  return (
    <HighchartsProvider>
      <Stack
        p={2}
        pl={1}
        pb={1}
        borderRadius={1}
        border={1}
        borderColor="grey.300"
        height={260}
      >
        <MultiTypeHighcharts
          showLegends
          maxHeight={240}
          loading={loading}
          chartType="column"
          chartScale="linear"
          chartData={chartData}
          yAxisLabelsFormatter={yAxisLabelsFormatter}
          tooltipMarkupGenerator={tooltipValueFormatter}
        />
      </Stack>
    </HighchartsProvider>
  );
};

const yAxisLabelsFormatter = getHighChartsYAxisLabelsFormatter("cost");
